export enum SourceTypes {
  Applicants = 'api.applicants',
  ProfileLeads = 'api.profileleads',
  Reqs = 'reqs',
  FeedReqs = 'FeedReqs',
  Snaplogic = 'Snaplogic',
}
